/** 补贴业务 */
import request from "@/utils/request"

/** 提交申请 */
export function submit(data) {
  return request({
    url: "/subsidy/submit",
    method: "post",
    data
  })
}
